"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mysqlParser = void 0;

var _ = require("../../..");

var _lexer = require("./lexer");

var _parser = require("./parser");

var mysqlParser = (0, _.createParser)(_parser.root, _lexer.sqlTokenizer, {
  cursorTokenExcludes: function cursorTokenExcludes(token) {
    return token.value === '.' || token.value === ':';
  }
});
exports.mysqlParser = mysqlParser;